'use strict';

import Backbone from 'backbone';
import $ from 'jquery';
import config from '../../../js/config';
import $global from '../../../js/globalElements';
import Overlay from '../templates/_AdvancedSearchFormOverlay.hbs';
import Analytics from '../../Analytics/Analytics';
import AdvancedSearchController from './AdvancedSearchController';

const OVERLAY_CLASSES = `${config.classes.hasAdvancedSearchOpen}`;

let instance = null;

export default class AdvancedSearchView extends Backbone.View {

  initialize() {
  }

  initializeElements() {

    this.advancedLayer = $(this.$advancedSearchOverlay.get(0));

    this.$form = this.advancedLayer.find('form');

    this.$searchTextBox = this.advancedLayer.find('#searchTerm');
    this.$submitButton = this.advancedLayer.find('#submit');
    this.$errorMessage = this.advancedLayer.find('#errorMessage');
    this.$searchInStockCheckbox = this.advancedLayer.find('#instock');
    this.$searchTopPurchasedCheckbox = this.advancedLayer.find('#topPurchased');
    this.$searchTopSearchedCheckbox = this.advancedLayer.find('#topSearched');
    this.$searchNewCheckbox = this.advancedLayer.find('#newProduct');
    this.$closeIcon = this.advancedLayer.find('.AdvancedSearchContent-close');
    this.$categoryList = this.advancedLayer.find('#AdvSearchCategoriesCategory');
    this.$manufacturerList = this.advancedLayer.find('#AdvSearchCategoriesManufacturer');
    this.$parametricList = this.advancedLayer.find('#AdvSearchParametric');
    this.$parametricListText = this.advancedLayer.find('#ParametricLabel');
    this.$parametricValueList = this.advancedLayer.find('#AdvSearchParametricValue');
    this.$parametricValueListText = this.advancedLayer.find('#ParametricValueLabel');
    this.$manufacturerLabel = this.advancedLayer.find('#ManufacturerLabel');
    this.$categoryLabel = this.advancedLayer.find('#CategoryLabel');
    this.$manufacturerForCategoryLabel = this.advancedLayer.find('#ManufacturerForCategoryLabel');
    this.$clearManufacturer = this.advancedLayer.find('#ClearManufacturer');
    this.$clearCategory = this.advancedLayer.find('#ClearCategory');
    this.$advMoreParametrics = this.advancedLayer.find('#AdvParametricMore');
    this.$parametricValues = this.advancedLayer.find('#parametricValues');

    this.initializeFormEvents();

    this.initializeControls();

  }

  initializeControls() {
    new AdvancedSearchController({
      $form: this.$form,
      $searchTextBox: this.$searchTextBox,
      $submitButton: this.$submitButton,
      $errorMessage: this.$errorMessage,
      $searchInStockCheckbox: this.$searchInStockCheckbox,
      $searchTopPurchasedCheckbox: this.$searchTopPurchasedCheckbox,
      $searchTopSearchedCheckbox: this.$searchTopSearchedCheckbox,
      $searchNewCheckbox: this.$searchNewCheckbox,
      $closeIcon: this.$closeIcon,
      $categoryList: this.$categoryList,
      $manufacturerList: this.$manufacturerList,
      $parametricList: this.$parametricList,
      $parametricListText: this.$parametricListText,
      $parametricValueList: this.$parametricValueList,
      $parametricValueListText: this.$parametricValueListText,
      $manufacturerLabel: this.$manufacturerLabel,
      $categoryLabel: this.$categoryLabel,
      $manufacturerForCategoryLabel: this.$manufacturerForCategoryLabel,
      $clearManufacturer: this.$clearManufacturer,
      $clearCategory: this.$clearCategory,
      $advMoreParametrics: this.$advMoreParametrics,
      $parametricValues: this.$parametricValues,
      model: this.model,
      instance: instance
    });
  }

  sendAnalytics(label,
    event = config.analytics.eventTypes.Click,
    category = config.analytics.categoryTypes.AdvancedSearch,
    action = config.analytics.actions.Click) {
    let data = {
      'event': event,
      'category': category,
      'action': action,
      'label': label
    };

    Analytics.pushToEventFramework(data);
  }

  initializeFormEvents() {
    this.$closeIcon.on('click', () => {
      this.sendAnalytics(config.analytics.labelTypes.AdvancedSearchClose);
      this.closeOverlayModal();
    });
  }

  openOverlayModal() {
    $global.$body.addClass(OVERLAY_CLASSES);
  }

  closeOverlayModal() {
    $global.$body.removeClass(OVERLAY_CLASSES);
  }

  open() {
    this.$advancedSearchOverlay = $('.Overlay--AdvancedSearchOpen');

    let data = {
      liveSupportUrl: config.salesforce.liveAgentSrcUrl,
      analyticsConfig: config.analytics
    };

    let template = Overlay(data);
    this.$advancedSearchOverlay.html(template);
    this.sendAnalytics(config.analytics.labelTypes.AdvancedSearch);
    this.openOverlayModal();
    this.initializeElements();
  };

  static handleOpenerClicked(e) {
    e.preventDefault();
    return;
  }

  static getInstance() {
    if (!instance) {
      instance = new AdvancedSearchView();
    }

    return instance;
  }

};

export function createAdvancedSearchView($parent) {
  let $advancedSearchBtn = $parent.find('.AdvancedSearchBtn');

  if ($advancedSearchBtn.length) {
    $advancedSearchBtn.on('click', AdvancedSearchView.handleOpenerClicked);
  }
}



// WEBPACK FOOTER //
// ./assets/components/Header/js/AdvancedSearchView.js